// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"creditcard-off","clipPath":"url(#clip0_543_8010)"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M17.001 10.0019H16.001L16 10.0009L17.001 10.0019ZM17.001 10.0019L22 10.001M22 10.001L22.001 10.0019L22 9.00096M22 10.001V9.00096M22 10.001V15.001M22 15.001V16.001L22.001 16.0019L22 15.001ZM11.001 4.00195H10.001L10 4.00095L11.001 4.00195ZM11.001 4.00195L22 4.00097V9.00096M6 15H9M2 10H9M4 4L2 4V20H20L4 4Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M22 22L2 2","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-creditcard-off')
export default class CreditcardOffIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'creditcard-off',
    }
  }
}
